import axios from "axios";
import * as Sentry from "@sentry/react";
import { DateTime } from "luxon";

type WithBaseProps<T> = T & {
  user_id: number;
  iso_timestamp: string;
  event: string;
};

export interface UserEvent {
  eventName: string;
  serializedData: WithBaseProps<Record<string, unknown>>;
}

abstract class AbsUserEvent<T> implements UserEvent {
  abstract eventName: string;

  protected _props: T;
  protected _userId: number;
  protected _timestamp: string;

  constructor(userId: number, props: T) {
    this._userId = userId;
    this._timestamp = DateTime.local().toISO();
    this._props = props;
  }

  get serializedData(): WithBaseProps<T> {
    return {
      event: this.eventName,
      user_id: this._userId,
      iso_timestamp: this._timestamp,
      ...this._props,
    };
  }
}

/**
 * EVENTS
 */

export class PrivacyPolicyAcceptedEvent extends AbsUserEvent<{ view: string }> {
  eventName = "privacy_policy_accepted";
}

/**
 * SENDER
 */
export const sendEvent = async (event: UserEvent): Promise<void> => {
  // only send if in production (see vite config/bb pipelines file for how
  // this global is defined/made available
  if (__ENV_NAME__ !== "production") {
    console.log("NOT IN PRODUCTION - NOT SENDING EVENT");
    console.log(event.serializedData);
    return;
  }

  try {
    await axios.post(
      // https://us-east-1.console.aws.amazon.com/apigateway/main/apis/dklmh2qt34/resources?api=dklmh2qt34&domain=event.mightier.com&region=us-east-1
      // the `v1` is the stage - but it includes stage in path (see "custom domain names" -> "API mappings")
      "https://event.mightier.com/v1/webeventreceiver",
      event.serializedData,
    );
  } catch (e) {
    Sentry.captureException(e);
  }
};
